<template>
    <modal ref="modal" title="Send by e-mail" :footerShow="false">
        <form @submit.prevent="action('submit')" ref="form" action="/" method="post">

            <div class="pt-0 pb-6">
                <input :disabled="status !== 'idle'" placeholder="Enter e-mail address" class="w-full border-gray-700 shadow-none bg-white px-0 py-2 border-b outline-none" type="email" name="email" v-model="email" required />
            </div>

            <div class="text-center mb-4 h-10">
                <input v-if="status === 'idle'" type="submit" name="subscribe" value="Send" class="btn text-center px-10 py-2 w-48 font-semibold rounded-full bg-ultramarine text-white cursor-pointer" />
                <loading-animation class="h-10" height="2.5rem" v-if="status === 'sending'"></loading-animation>
                <p class="text-lg text-green-600 font-semibold" v-if="status === 'sent'">A message has been sent</p>
            </div>

        </form>
    </modal>
</template>

<script>
    import Modal from './Modal'
    import axios from 'axios'
    let token = document.head.querySelector('meta[name="csrf-token"]');
    if (token) {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }

    export default {
        name: "MailerModal",
        components: {
            Modal,
        },
        props: {
            endpoint: {
                default: '/mailer'
            },
            postId: null,
        },
        methods: {
            showModal() {
                this.$refs['modal'].show();
            },
            action(action) {
                switch (this.status) {
                    case 'idle': {
                        return this.actionWhenIdle(action);
                    }
                }
            },
            actionWhenIdle(action) {
                switch (action) {
                    case 'submit': {
                        return this.submit();
                    }
                }
            },
            submit() {
                this.status = 'sending';

                axios.post(this.endpoint, {
                    postId: this.postId,
                    email: this.email,
                }).then((response) => {
                    // handle success
                    this.status = 'sent';
                }).catch((error) => {
                    // handle error
                    this.status = 'idle';
                });
            }
        },
        data() {
            return {
                status: 'idle',
                email: null,
            };
        }
    }
</script>

<style scoped>

</style>